<template>
  <Modal id="poll-start" modifier="poll" #default="{ close }">
    <div class="close" @click="close">
      <SvgIcon name="close" />
    </div>

    <h2>Выберите как вы хотите ответить на итоговый опрос о школе?</h2>

    <SelectList :options="options" :selected="selected" @onSelect="(v) => (selected = v)" />

    <div class="note">После того как вы примете решение, поменять его будет невозможно.</div>
    <div class="actions">
      <button @click="handleSubmit" class="blue">Submit</button>
    </div>
  </Modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import { withUi } from '@/components/ui'
import Modal from '@/components/modals/Modal'

export default {
  name: 'ModalPollQuestion',
  components: { Modal },
  mixins: [withUi],
  data() {
    return {
      selected: 1,
      options: [
        { id: 1, title: 'Публично' },
        { id: 2, title: 'Анонимно' },
      ],
    }
  },
  computed: {
    ...mapState(['modal']),
  },
  methods: {
    reset() {
      this.selected = null
    },
    handleSubmit() {
      this.setAnonymos(this.selected === 1 ? false : true)
      this.closeModal()
    },
    ...mapMutations(['closeModal']),
    ...mapMutations('polls', ['setAnonymos']),
  },
  watch: {
    modal(val) {
      if (val === false) {
        this.reset()
      }
    },
  },
}
</script>

<style lang="scss">
#modal-poll-start {
  .close {
    position: absolute;
    z-index: 3;
    top: 20px;
    right: 10px;
    color: $dark;
    font-size: 0;
    padding: 10px;
    cursor: pointer;
    transition: color 0.25s $ease;
    .svg-icon {
      font-size: 14px;
    }
    &:hover {
      color: $primary;
    }
  }
  h2 {
    font-size: 14px;
    margin-bottom: 32px;
    text-align: left;
  }
  .note {
    margin-top: -16px;
    font-size: 12px;
    line-height: 1.47;
    color: $dark;
  }
  .actions {
    margin-top: 60px;
    button {
      width: 100%;
      height: 40px;
    }
  }
}
</style>
